import React from 'react';

import './OurStoryContact.css';
import Heading from '../../../utls/Heading';

const OurStoryContact = () => {
    return (
        <>

            <div className="ourtstory-contact">


                <div className="container ">

                    <div className="row">
                        <div className="col-md-6"></div>
                        <div className="col-md-6">
                            <div className="contact-txt position-absolute">
                                <Heading className='customheadings'>Ready to Begin Your Journey?</Heading>
                                <p>Join us on this journey to redefine corporate travel. Contact us <br /> today to learn how we can transform your travel experience.</p>
                                <div className="carouselCaption">
                                    <a href="/contact">
                                        <button className="btn  text-white mt-md-3 grotesk-headings fw-bold">CONTACT US</button>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default OurStoryContact